<template>
  <div style="display:none;">
    <svg
      style="position: absolute; width: 0; height: 0; overflow: hidden;"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <symbol id="anz-icon-chevron-down" viewBox="0 0 24 24">
          <title>chevron-down</title>
          <path
            d="M5.419 9.058c0.523-0.535 1.252-0.577 1.891 0l4.69 4.496 4.69-4.496c0.64-0.577 1.369-0.535 1.889 0 0.523 0.534 0.49 1.436 0 1.938-0.487 0.502-5.634 5.402-5.634 5.402-0.26 0.268-0.602 0.402-0.944 0.402s-0.684-0.134-0.947-0.402c0 0-5.144-4.901-5.634-5.402-0.491-0.502-0.523-1.404 0-1.938z"
          ></path>
        </symbol>
        <symbol id="anz-icon-chevron-up" viewBox="0 0 24 24">
          <title>chevron-up</title>
          <path
            d="M18.581 14.942c-0.523 0.535-1.252 0.577-1.891 0l-4.69-4.496-4.69 4.496c-0.64 0.577-1.369 0.535-1.889 0-0.523-0.534-0.49-1.436 0-1.938 0.487-0.502 5.634-5.402 5.634-5.402 0.26-0.268 0.602-0.402 0.944-0.402s0.684 0.134 0.947 0.402c0 0 5.144 4.901 5.634 5.402 0.491 0.502 0.523 1.404 0 1.938z"
          ></path>
        </symbol>
        <symbol id="anz-icon-arrow-right" viewBox="0 0 30 30">
          <g transform="matrix(2.142857142857143,0,0,2.142857142857143,0,0)">
            <path
              d="M3.4,13.707a1,1,0,0,1,0-1.414L8.513,7.177a.25.25,0,0,0,0-.354L3.4,1.707A1,1,0,0,1,4.811.293l5.646,5.646a1.5,1.5,0,0,1,0,2.122L4.811,13.707A1,1,0,0,1,3.4,13.707Z"
              stroke="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0"
            ></path>
          </g>
        </symbol>
        <symbol id="anz-icon-copy" viewBox="0 0 140 140">
          <g transform="matrix(5.833333333333333,0,0,5.833333333333333,0,0)">
            <path
              d="M21.811,3.854,18.4.441A1.5,1.5,0,0,0,17.336,0H6.75a1.5,1.5,0,0,0-1.5,1.5V19a1.5,1.5,0,0,0,1.5,1.5h14a1.5,1.5,0,0,0,1.5-1.5V4.914A1.492,1.492,0,0,0,21.811,3.854Z"
              stroke="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0"
            ></path>
            <path
              d="M17.75,22h-13a1,1,0,0,1-1-1V3.5a1,1,0,0,0-2,0V21a3,3,0,0,0,3,3h13a1,1,0,0,0,0-2Z"
              stroke="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0"
            ></path>
          </g>
        </symbol>
        <symbol id="anz-icon-bell" viewBox="0 0 140 140">
          <g transform="matrix(5.833333333333333,0,0,5.833333333333333,0,0)">
            <path
              d="M21,17.5A1.5,1.5,0,0,1,19.5,16V11.138A7.957,7.957,0,0,0,13,3.073V1a1,1,0,0,0-2,0V3.073a7.957,7.957,0,0,0-6.5,8.065V16A1.5,1.5,0,0,1,3,17.5a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Z"
              stroke="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0"
            ></path>
            <path
              d="M14.236,21H9.764a.25.25,0,0,0-.248.222A2.319,2.319,0,0,0,9.5,21.5a2.5,2.5,0,1,0,5,0,2.319,2.319,0,0,0-.016-.278A.248.248,0,0,0,14.236,21Z"
              stroke="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0"
            ></path>
          </g>
        </symbol>
        <symbol id="anz-icon-check" viewBox="0 0 33 24">
          <path
            d="M11.999 24c-0.702 0-1.407-0.246-1.977-0.741l-9-7.5c-1.245-1.092-1.371-2.988-0.279-4.233 1.089-1.248 2.985-1.374 4.233-0.285l6.888 5.655 16.014-16.017c1.173-1.173 3.069-1.173 4.242 0s1.173 3.069 0 4.242l-18 17.999c-0.582 0.582-1.353 0.879-2.121 0.879z"
          ></path>
        </symbol>
        <symbol id="anz-icon-check-circle" viewBox="0 0 140 140">
          <g transform="matrix(5.833333333333333,0,0,5.833333333333333,0,0)">
            <path
              d="M18.48,6.449a1.249,1.249,0,0,0-1.747.265l-5.924,8.04L7.042,11.74a1.251,1.251,0,0,0-1.563,1.953l4.783,3.826a1.263,1.263,0,0,0,1.787-.235l6.7-9.087A1.25,1.25,0,0,0,18.48,6.449Z"
              stroke="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0"
            ></path>
            <path
              d="M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10.011,10.011,0,0,1,12,22Z"
              stroke="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0"
            ></path>
          </g>
        </symbol>
        <symbol id="anz-icon-map-navigation" viewBox="0 0 140 140">
          <g transform="matrix(10,0,0,10,0,0)">
            <path
              d="M13.854.146A.5.5,0,0,0,13.32.033l-13,5a.5.5,0,0,0,.022.941L6.105,7.9l1.921,5.763A.5.5,0,0,0,8.489,14H8.5a.5.5,0,0,0,.467-.32l5-13A.5.5,0,0,0,13.854.146Z"
              stroke="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0"
            ></path>
          </g>
        </symbol>
        <symbol id="anz-icon-cross-solid" viewBox="0 0 140 140">
          <g transform="matrix(10,0,0,10,0,0)">
            <path
              d="M8.591,7.177a.25.25,0,0,1,0-.354l4.616-4.616A1,1,0,1,0,11.793.793L7.177,5.409a.25.25,0,0,1-.354,0L2.207.793A1,1,0,0,0,.793,2.207L5.409,6.823a.25.25,0,0,1,0,.354L.793,11.793a1,1,0,0,0,1.414,1.414L6.823,8.591a.25.25,0,0,1,.354,0l4.616,4.616a1,1,0,0,0,1.414-1.414Z"
              stroke="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0"
            ></path>
          </g>
        </symbol>
        <symbol id="anz-icon-emoji-stroke" viewBox="0 0 140 140">
          <g transform="matrix(5.833333333333333,0,0,5.833333333333333,0,0)">
            <path
              d="M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10.011,10.011,0,0,1,12,22Z"
              stroke="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0"
            ></path>
            <path
              d="M16.492,14.13a1,1,0,0,0-1.362.378A3.656,3.656,0,0,1,12,16.5a3.656,3.656,0,0,1-3.13-1.992,1,1,0,0,0-1.74.984A5.624,5.624,0,0,0,12,18.5a5.624,5.624,0,0,0,4.87-3.008A1,1,0,0,0,16.492,14.13Z"
              stroke="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0"
            ></path>
            <path
              d="M6.000 9.000 A2.000 2.000 0 1 0 10.000 9.000 A2.000 2.000 0 1 0 6.000 9.000 Z"
              stroke="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0"
            ></path>
            <path
              d="M14.000 9.000 A2.000 2.000 0 1 0 18.000 9.000 A2.000 2.000 0 1 0 14.000 9.000 Z"
              stroke="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0"
            ></path>
          </g>
        </symbol>
        <symbol id="anz-icon-emoji" viewBox="0 0 140 140">
          <g transform="matrix(5.833333333333333,0,0,5.833333333333333,0,0)">
            <path
              d="M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0ZM8,7A2,2,0,1,1,6,9,2,2,0,0,1,8,7ZM6.844,14.162a1,1,0,0,1,1.384.291,4.5,4.5,0,0,0,7.544,0,1,1,0,0,1,1.676,1.094,6.5,6.5,0,0,1-10.9,0A1,1,0,0,1,6.844,14.162ZM16,11a2,2,0,1,1,2-2A2,2,0,0,1,16,11Z"
              stroke="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0"
            ></path>
          </g>
        </symbol>
        <symbol id="anz-icon-like" viewBox="0 0 140 140">
          <g transform="matrix(5.833333333333333,0,0,5.833333333333333,0,0)">
            <path
              d="M23.756,12.174a2.749,2.749,0,0,0-2.63-3.551h-5.58a1.249,1.249,0,0,1-1.127-1.788l1.428-2.993a2.425,2.425,0,0,0-.42-2.308,2.464,2.464,0,0,0-3.926.132L6.611,8.594a1.253,1.253,0,0,1-1.021.529.464.464,0,0,0-.464.464V20.9a.5.5,0,0,0,.282.45c3.7,1.792,4.929,2.029,7.942,2.029.347,0,2.32-.02,3.041-.02,2.68,0,4.463-1.555,5.456-4.779l1.9-6.369Z"
              stroke="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0"
            ></path>
            <path
              d="M3.626,9.123H3.6a1.5,1.5,0,0,0-1.474-1.25H.626a.5.5,0,0,0-.5.5v14a.5.5,0,0,0,.5.5h1.5a1.5,1.5,0,0,0,1.5-1.5Z"
              stroke="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0"
            ></path>
          </g>
        </symbol>
        <symbol id="anz-icon-dislike" viewBox="0 0 140 140">
          <g transform="matrix(5.833333333333333,0,0,5.833333333333333,0,0)">
            <path
              d="M.244,11.826a2.749,2.749,0,0,0,2.63,3.551h5.58a1.249,1.249,0,0,1,1.127,1.788L8.153,20.158a2.425,2.425,0,0,0,.42,2.308,2.464,2.464,0,0,0,3.926-.132l4.89-6.928a1.253,1.253,0,0,1,1.021-.529.464.464,0,0,0,.464-.464V3.1a.5.5,0,0,0-.282-.45C14.891.86,13.663.623,10.65.623c-.347,0-2.32.02-3.041.02C4.929.643,3.146,2.2,2.153,5.422l-1.9,6.369Z"
              stroke="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0"
            ></path>
            <path
              d="M20.374,14.877H20.4a1.5,1.5,0,0,0,1.474,1.25h1.5a.5.5,0,0,0,.5-.5v-14a.5.5,0,0,0-.5-.5h-1.5a1.5,1.5,0,0,0-1.5,1.5Z"
              stroke="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0"
            ></path>
          </g>
        </symbol>
        <symbol id="anz-icon-megaphone" viewBox="0 0 140 140">
          <g transform="matrix(5.833333333333333,0,0,5.833333333333333,0,0)">
            <path
              d="M24,1.749a1,1,0,1,0-2,0v.774L3.846,8.384A.5.5,0,0,0,3.5,8.86v5.957a.5.5,0,0,0,.35.477l1.3.408a.5.5,0,0,1,.35.477V18.77A4.505,4.505,0,0,0,10,23.25h.021A4.505,4.505,0,0,0,14.5,18.733v-.1L22,20.983v.766a1,1,0,0,0,2,0ZM12.5,18.738a2.5,2.5,0,0,1-2.488,2.512H10a2.5,2.5,0,0,1-2.5-2.484V17.119a.5.5,0,0,1,.65-.477l4,1.254a.5.5,0,0,1,.35.477Z"
              stroke="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0"
            ></path>
            <path
              d="M2,8.249a1,1,0,0,0-1-1H1a1,1,0,0,0-1,1l.005,7a1,1,0,0,0,1,1H1a1,1,0,0,0,1-.976Z"
              stroke="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0"
            ></path>
          </g>
        </symbol>
        <symbol id="anz-icon-trash" viewBox="0 0 140 140">
          <g transform="matrix(5.833333333333333,0,0,5.833333333333333,0,0)">
            <path
              d="M19.452,7.5H4.547a.5.5,0,0,0-.5.545L5.334,22.181A2,2,0,0,0,7.326,24h9.347a2,2,0,0,0,1.992-1.819L19.95,8.045a.5.5,0,0,0-.129-.382A.5.5,0,0,0,19.452,7.5Zm-9.2,13a.75.75,0,0,1-1.5,0v-9a.75.75,0,0,1,1.5,0Zm5,0a.75.75,0,0,1-1.5,0v-9a.75.75,0,0,1,1.5,0Z"
              stroke="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0"
            ></path>
            <path
              d="M22,4H17.25A.25.25,0,0,1,17,3.75V2.5A2.5,2.5,0,0,0,14.5,0h-5A2.5,2.5,0,0,0,7,2.5V3.75A.25.25,0,0,1,6.75,4H2A1,1,0,0,0,2,6H22a1,1,0,0,0,0-2ZM9,3.75V2.5A.5.5,0,0,1,9.5,2h5a.5.5,0,0,1,.5.5V3.75a.25.25,0,0,1-.25.25H9.25A.25.25,0,0,1,9,3.75Z"
              stroke="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0"
            ></path>
          </g>
        </symbol>
        <symbol id="anz-icon-clock" viewBox="0 0 140 140">
          <g transform="matrix(5.833333333333333,0,0,5.833333333333333,0,0)">
            <path
              d="M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10.011,10.011,0,0,1,12,22Z"
              stroke="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0"
            ></path>
            <path
              d="M17.134,15.81,12.5,11.561V6.5a1,1,0,0,0-2,0V12a1,1,0,0,0,.324.738l4.959,4.545a1.01,1.01,0,0,0,1.413-.061A1,1,0,0,0,17.134,15.81Z"
              stroke="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0"
            ></path>
          </g>
        </symbol>
        <symbol id="anz-icon-remove-circle" viewBox="0 0 140 140">
          <g transform="matrix(5.833333333333333,0,0,5.833333333333333,0,0)">
            <path
              d="M.249,12A11.751,11.751,0,1,0,12,.249,11.765,11.765,0,0,0,.249,12Zm21,0A9.251,9.251,0,1,1,12,2.749,9.262,9.262,0,0,1,21.251,12Z"
              stroke="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0"
            ></path>
            <path
              d="M8.833,7.066A1.25,1.25,0,1,0,7.065,8.834l2.99,2.989a.25.25,0,0,1,0,.354l-2.99,2.99a1.25,1.25,0,1,0,1.768,1.767l2.989-2.989a.249.249,0,0,1,.354,0l2.99,2.989a1.249,1.249,0,1,0,1.767-1.767l-2.989-2.99a.25.25,0,0,1,0-.354l2.989-2.989a1.25,1.25,0,1,0-1.767-1.768l-2.99,2.99a.251.251,0,0,1-.354,0Z"
              stroke="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0"
            ></path>
          </g>
        </symbol>
        <symbol id="anz-icon-fb" viewBox="0 0 140 140">
          <g transform="matrix(10,0,0,10,0,0)">
            <path
              d="M14,1.539A1.54,1.54,0,0,0,12.462,0H1.538A1.54,1.54,0,0,0,0,1.539V12.461A1.54,1.54,0,0,0,1.538,14H6.507a.25.25,0,0,0,.25-.25V9.012a.25.25,0,0,0-.25-.25H6.115A.615.615,0,0,1,5.5,8.147V7.384a.615.615,0,0,1,.615-.616h.392a.25.25,0,0,0,.25-.25V5.6A2.321,2.321,0,0,1,9.147,3c.212,0,.693.013,1.15.02a.614.614,0,0,1,.6.615v.744A.615.615,0,0,1,10.286,5H9.8c-.38,0-.761,0-.761.839v.685a.25.25,0,0,0,.25.25h.46a.616.616,0,0,1,.615.616v.763a.615.615,0,0,1-.615.615h-.46a.25.25,0,0,0-.25.25V13.75a.25.25,0,0,0,.25.25h3.176A1.54,1.54,0,0,0,14,12.461Z"
              stroke="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0"
            ></path>
          </g>
        </symbol>
        <symbol id="anz-icon-tw" viewBox="0 0 30 32">
          <path
            d="M28.929 7.286q-1.196 1.75-2.893 2.982 0.018 0.25 0.018 0.75 0 2.321-0.679 4.634t-2.063 4.437-3.295 3.759-4.607 2.607-5.768 0.973q-4.839 0-8.857-2.589 0.625 0.071 1.393 0.071 4.018 0 7.161-2.464-1.875-0.036-3.357-1.152t-2.036-2.848q0.589 0.089 1.089 0.089 0.768 0 1.518-0.196-2-0.411-3.313-1.991t-1.313-3.67v-0.071q1.214 0.679 2.607 0.732-1.179-0.786-1.875-2.054t-0.696-2.75q0-1.571 0.786-2.911 2.161 2.661 5.259 4.259t6.634 1.777q-0.143-0.679-0.143-1.321 0-2.393 1.688-4.080t4.080-1.688q2.5 0 4.214 1.821 1.946-0.375 3.661-1.393-0.661 2.054-2.536 3.179 1.661-0.179 3.321-0.893z"
          ></path>
        </symbol>
        <symbol id="anz-icon-instagram" viewBox="0 0 27 32">
          <path
            d="M18.286 16q0-1.893-1.339-3.232t-3.232-1.339-3.232 1.339-1.339 3.232 1.339 3.232 3.232 1.339 3.232-1.339 1.339-3.232zM20.75 16q0 2.929-2.054 4.982t-4.982 2.054-4.982-2.054-2.054-4.982 2.054-4.982 4.982-2.054 4.982 2.054 2.054 4.982zM22.679 8.679q0 0.679-0.482 1.161t-1.161 0.482-1.161-0.482-0.482-1.161 0.482-1.161 1.161-0.482 1.161 0.482 0.482 1.161zM13.714 4.75q-0.125 0-1.366-0.009t-1.884 0-1.723 0.054-1.839 0.179-1.277 0.33q-0.893 0.357-1.571 1.036t-1.036 1.571q-0.196 0.518-0.33 1.277t-0.179 1.839-0.054 1.723 0 1.884 0.009 1.366-0.009 1.366 0 1.884 0.054 1.723 0.179 1.839 0.33 1.277q0.357 0.893 1.036 1.571t1.571 1.036q0.518 0.196 1.277 0.33t1.839 0.179 1.723 0.054 1.884 0 1.366-0.009 1.366 0.009 1.884 0 1.723-0.054 1.839-0.179 1.277-0.33q0.893-0.357 1.571-1.036t1.036-1.571q0.196-0.518 0.33-1.277t0.179-1.839 0.054-1.723 0-1.884-0.009-1.366 0.009-1.366 0-1.884-0.054-1.723-0.179-1.839-0.33-1.277q-0.357-0.893-1.036-1.571t-1.571-1.036q-0.518-0.196-1.277-0.33t-1.839-0.179-1.723-0.054-1.884 0-1.366 0.009zM27.429 16q0 4.089-0.089 5.661-0.179 3.714-2.214 5.75t-5.75 2.214q-1.571 0.089-5.661 0.089t-5.661-0.089q-3.714-0.179-5.75-2.214t-2.214-5.75q-0.089-1.571-0.089-5.661t0.089-5.661q0.179-3.714 2.214-5.75t5.75-2.214q1.571-0.089 5.661-0.089t5.661 0.089q3.714 0.179 5.75 2.214t2.214 5.75q0.089 1.571 0.089 5.661z"
          ></path>
        </symbol>
        <symbol id="anz-icon-linkedin" viewBox="0 0 140 140">
          <g transform="matrix(10,0,0,10,0,0)">
            <path
              d="M2.34,4.459H1.865a1.276,1.276,0,0,0-.973.219.944.944,0,0,0-.235.712V13.1a.908.908,0,0,0,.23.7.924.924,0,0,0,.682.2c.222,0,.415-.021.824-.006a1.2,1.2,0,0,0,.925-.2.91.91,0,0,0,.229-.7V5.39a.944.944,0,0,0-.234-.712A1.268,1.268,0,0,0,2.34,4.459Z"
              stroke="none"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
            <path
              d="M2.1,0A1.619,1.619,0,0,0,.509,1.56,1.652,1.652,0,0,0,2.1,3.186,1.612,1.612,0,0,0,3.7,1.56,1.618,1.618,0,0,0,2.1,0Z"
              stroke="none"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
            <path
              d="M9.974,4.363a3.109,3.109,0,0,0-2.093.63A.725.725,0,0,0,7.7,4.634a.608.608,0,0,0-.452-.178,11.908,11.908,0,0,0-1.5.03c-.416.084-.618.379-.618.9V13.1a.914.914,0,0,0,.228.7,1.206,1.206,0,0,0,.926.2c.447-.017.574.006.822.006a.926.926,0,0,0,.683-.2.912.912,0,0,0,.23-.7V8.988A1.248,1.248,0,0,1,9.293,7.6,1.244,1.244,0,0,1,10.6,8.988V13.1a.91.91,0,0,0,.229.7,1.2,1.2,0,0,0,.924.2c.183-.007.4-.007.58,0a1.209,1.209,0,0,0,.926-.2.914.914,0,0,0,.228-.7V7.832A3.307,3.307,0,0,0,9.974,4.363Z"
              stroke="none"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
          </g>
        </symbol>
        <symbol id="anz-icon-whatsapp" viewBox="0 0 140 140">
          <g transform="matrix(5.833333333333333,0,0,5.833333333333333,0,0)">
            <path
              d="M12,.09A12,12,0,0,0,0,12a11.74,11.74,0,0,0,2.14,6.77l-1.35,4a.5.5,0,0,0,.12.51.51.51,0,0,0,.51.13l4.2-1.33A12,12,0,0,0,24,12,12,12,0,0,0,12,.09Zm7.2,16.72a3.91,3.91,0,0,1-3.5,2.09,10.71,10.71,0,0,1-3.45-1A14,14,0,0,1,6.3,12.74c-1.91-2.53-2-4.9-.16-6.86A2.17,2.17,0,0,1,8,5.32a1.54,1.54,0,0,1,1.21.87l.38.92c.28.67.58,1.39.63,1.51a1.1,1.1,0,0,1,0,1,5.14,5.14,0,0,1-1,1.37,12.41,12.41,0,0,0,1.79,2.15,9.06,9.06,0,0,0,2.73,1.63c.28-.36.83-1,1-1.27a1,1,0,0,1,1.34-.36c.38.14,2.51,1.18,2.51,1.18a1.43,1.43,0,0,1,.68.49h0A2,2,0,0,1,19.2,16.81Z"
              stroke="none"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
          </g>
        </symbol>
        <symbol id="anz-icon-messenger" viewBox="0 0 24 24">
          <path
            d="M12,2C6.36,2 2,6.13 2,11.7C2,14.61 3.19,17.14 5.14,18.87C5.3,19 5.4,19.22 5.41,19.44L5.46,21.22C5.5,21.79 6.07,22.16 6.59,21.93L8.57,21.06C8.74,21 8.93,20.97 9.1,21C10,21.27 11,21.4 12,21.4C17.64,21.4 22,17.27 22,11.7C22,6.13 17.64,2 12,2M18,9.46L15.07,14.13C14.6,14.86 13.6,15.05 12.9,14.5L10.56,12.77C10.35,12.61 10.05,12.61 9.84,12.77L6.68,15.17C6.26,15.5 5.71,15 6,14.54L8.93,9.87C9.4,9.14 10.4,8.95 11.1,9.47L13.44,11.23C13.66,11.39 13.95,11.39 14.16,11.23L17.32,8.83C17.74,8.5 18.29,9 18,9.46Z"
          />
        </symbol>
        <symbol id="anz-icon-viber" viewBox="0 0 50 50">
          <path
            d="M44.781 13.156c-.781-2.789-2.328-4.992-4.593-6.55-2.86-1.973-6.149-2.668-8.989-3.094-3.93-.586-7.488-.668-10.883-.254-3.18.39-5.574 1.012-7.757 2.015-4.282 1.97-6.852 5.153-7.637 9.461a58.837 58.837 0 0 0-.79 5.79c-.343 4.171-.03 7.863.954 11.285.96 3.336 2.637 5.718 5.125 7.285.633.398 1.445.687 2.23.965.446.156.88.308 1.235.476.328.153.328.18.324.453-.027 2.371 0 7.02 0 7.02l.008.992h1.781l.29-.281c.19-.18 4.605-4.446 6.179-6.164l.215-.239c.27-.312.27-.312.547-.316 2.125-.043 4.296-.125 6.453-.242 2.613-.14 5.64-.395 8.492-1.582 2.61-1.09 4.515-2.82 5.66-5.14 1.195-2.423 1.902-5.044 2.168-8.016.469-5.227.137-9.762-1.012-13.864zM35.383 33.48c-.656 1.067-1.633 1.81-2.785 2.29-.844.351-1.703.277-2.535-.075-6.965-2.949-12.43-7.593-16.04-14.273-.746-1.375-1.261-2.875-1.855-4.328-.121-.297-.113-.649-.168-.977.05-2.347 1.852-3.672 3.672-4.07.695-.156 1.312.09 1.828.586a16.005 16.005 0 0 1 3.41 4.715c.371.777.203 1.465-.43 2.043-.132.12-.27.23-.414.34-1.445 1.085-1.656 1.91-.886 3.546 1.312 2.785 3.492 4.657 6.308 5.817.742.304 1.442.152 2.008-.45.078-.078.164-.156.219-.25 1.11-1.851 2.723-1.667 4.21-.613.977.696 1.927 1.43 2.891 2.137 1.473 1.082 1.461 2.098.567 3.562zM26.145 15c-.329 0-.657.027-.98.082a.999.999 0 1 1-.328-1.973c.429-.074.87-.109 1.308-.109C30.477 13 34 16.523 34 20.855c0 .442-.035.883-.11 1.31a1 1 0 0 1-1.972-.33A5.865 5.865 0 0 0 26.145 15zM31 21c0 .55-.45 1-1 1s-1-.45-1-1c0-1.652-1.348-3-3-3-.55 0-1-.45-1-1s.45-1 1-1c2.758 0 5 2.242 5 5zm5.71 2.223a1 1 0 0 1-1.952-.446 8.875 8.875 0 0 0 .219-1.96c0-4.86-3.957-8.817-8.817-8.817-.664 0-1.324.074-1.96.219a.996.996 0 0 1-1.196-.754.996.996 0 0 1 .754-1.195c.781-.18 1.59-.27 2.402-.27 5.965 0 10.817 4.852 10.817 10.816 0 .813-.09 1.622-.266 2.407z"
          />
        </symbol>
        <symbol id="anz-icon-user" viewBox="0 0 12 12">
          <path
            d="M3,0A3,3,0,0,0,3,6H3A3,3,0,0,0,3,0Z"
            transform="translate(3)"
          />
          <path
            d="M8.445,0A4.166,4.166,0,0,1,6,.78,4.166,4.166,0,0,1,3.555,0,4.585,4.585,0,0,0,0,4.47V5.58H12V4.47A4.585,4.585,0,0,0,8.445,0Z"
            transform="translate(0 6.42)"
          />
        </symbol>
        <symbol id="anz-icon-lock" viewBox="0 0 140 140">
          <g transform="matrix(5.833333333333333,0,0,5.833333333333333,0,0)">
            <path
              d="M19.5,9.5h-.75V6.75a6.75,6.75,0,0,0-13.5,0V9.5H4.5a2,2,0,0,0-2,2V22a2,2,0,0,0,2,2h15a2,2,0,0,0,2-2V11.5A2,2,0,0,0,19.5,9.5Zm-9.5,6a2,2,0,1,1,3,1.723V19.5a1,1,0,0,1-2,0V17.223A1.994,1.994,0,0,1,10,15.5ZM7.75,6.75a4.25,4.25,0,0,1,8.5,0V9a.5.5,0,0,1-.5.5H8.25a.5.5,0,0,1-.5-.5Z"
              stroke="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0"
            ></path>
          </g>
        </symbol>
        <symbol id="anz-icon-settings-menu" viewBox="0 0 141 36">
          <g>
            <path
              d="M105.432,18c0,9.6 7.9,17.5 17.5,17.5c9.601,0 17.5,-7.9 17.5,-17.5c0,-9.6 -7.899,-17.5 -17.5,-17.5c-9.6,0 -17.5,7.9 -17.5,17.5Z"
              style="fill-rule:nonzero;"
            />
            <path
              d="M52.932,18c0,9.6 7.9,17.5 17.5,17.5c9.601,0 17.5,-7.9 17.5,-17.5c0,-9.6 -7.899,-17.5 -17.5,-17.5c-9.6,0 -17.5,7.9 -17.5,17.5Z"
              style="fill-rule:nonzero;"
            />
            <path
              d="M0.432,18c0,9.6 7.9,17.5 17.5,17.5c9.601,0 17.5,-7.9 17.5,-17.5c0,-9.6 -7.899,-17.5 -17.5,-17.5c-9.6,0 -17.5,7.9 -17.5,17.5Z"
              style="fill-rule:nonzero;"
            />
          </g>
        </symbol>
        <symbol id="anz-icon-share" viewBox="0 0 12 14">
          <g fill-rule="evenodd">
            <g fill-rule="nonzero">
              <g>
                <g>
                  <g>
                    <path
                      d="M3.748 7.887c-.09-.06-.183-.113-.28-.164-.097-.047-.198-.09-.302-.128-.235-.079-.487-.12-.746-.12-.292 0-.572.054-.83.152-.113.043-.217.092-.32.152-.206.114-.395.264-.56.434-.082.086-.158.179-.228.277-.037.05-.074.105-.106.16-.052.083-.094.165-.138.254-.033.074-.063.15-.09.226-.027.083-.052.168-.074.258-.007.028-.012.06-.019.092-.015.06-.025.121-.03.184-.007.032-.008.063-.012.095-.003.023-.006.044-.006.066C.003 9.883 0 9.94 0 10c0 .016 0 .035.003.051 0 .11.009.219.026.333v.007c.006.043.011.089.021.133l.012.047c.09.403.27.769.517 1.07.348.429.824.733 1.366.842.034.007.064.012.098.012.042.009.085.012.13.02l.106.008h.029c.037.003.076.003.112.003.046 0 .091 0 .135-.007.03 0 .057 0 .089-.003.006 0 .015-.004.022-.004.078-.007.157-.019.236-.035.042-.008.082-.022.124-.031.08-.023.153-.044.229-.074.15-.057.292-.13.426-.213.124-.082.243-.175.353-.277l.085-.082 3.032 1.896v.777c0 1.558 1.363 2.794 2.914 2.477.94-.194 1.702-.987 1.886-1.968.304-1.615-.88-3.04-2.375-3.04-.663 0-1.26.28-1.699.73l-3.033-1.9-.035-.022-.062-.039c.064-.226.097-.464.097-.71 0-.247-.033-.486-.097-.711l.097-.06L7.88 7.33c.539.558 1.328.847 2.17.683.947-.188 1.711-.979 1.9-1.96.341-1.767-1.099-3.311-2.787-3.015-.898.155-1.644.86-1.906 1.775-.149.51-.127.99-.003 1.432L4.12 8.199c-.112-.116-.236-.219-.37-.312z"
                      transform="translate(-39.000000, -961.000000) translate(20.000000, 786.000000) translate(0.000000, 165.000000) translate(19.000000, 7.000000)"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </symbol>
        <symbol id="anz-icon-exclamation-circle" viewBox="0 0 140 140">
          <g transform="matrix(10,0,0,10,0,0)">
            <path
              d="M7,0a7,7,0,1,0,7,7A7.008,7.008,0,0,0,7,0ZM6.25,3.5a.75.75,0,0,1,1.5,0v3a.75.75,0,0,1-1.5,0ZM7,11a1,1,0,1,1,1-1A1,1,0,0,1,7,11Z"
              stroke="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0"
            ></path>
          </g>
        </symbol>
        <symbol id="anz-icon-star" viewBox="0 0 30 30">
          <g transform="matrix(1.25,0,0,1.25,0,0)">
            <path
              d="M23.56,8.73a1.51,1.51,0,0,0-1.41-1H16.06a.5.5,0,0,1-.47-.33l-2.18-6.2A1.52,1.52,0,0,0,12,.25a1.49,1.49,0,0,0-1.4,1v0L8.41,7.42a.5.5,0,0,1-.47.33H1.85a1.5,1.5,0,0,0-1.41,1A1.52,1.52,0,0,0,.89,10.4l5.18,4.3a.5.5,0,0,1,.16.54L4.05,21.77a1.5,1.5,0,0,0,2.31,1.69l5.34-3.92a.49.49,0,0,1,.59,0l5.35,3.92A1.5,1.5,0,0,0,20,21.77l-2.18-6.53a.5.5,0,0,1,.16-.54l5.19-4.31A1.51,1.51,0,0,0,23.56,8.73Z"
            ></path>
          </g>
        </symbol>
        <symbol id="anz-icon-edit" viewBox="0 0 10 10">
          <path
            d="M7.603 0a.313.313 0 0 0-.217.093l-.978.975L8.93 3.587l.98-.978a.312.312 0 0 0 0-.44L7.828.093A.313.313 0 0 0 7.603 0zM5.966 1.51 1.153 6.315a.312.312 0 0 0-.09.219L1.054 8.62a.312.312 0 0 0 .314.313l2.089-.01a.313.313 0 0 0 .22-.091l4.811-4.805L5.966 1.51zM.306 9.376a.313.313 0 0 0 0 .624H8.63a.313.313 0 0 0 0-.624H.306z"
            fill-rule="nonzero"
          />
        </symbol>
      </defs>
    </svg>
  </div>
</template>

<script lang="ts">
export default {
  name: 'IconsSprite',
}
</script>
